export class TokenExpiredError extends Error {
  constructor() {
    super('Время действия токена истекло!');
    this.name = 'TokenExpiredError';
  }
}
